import React from "react";
import "./style.css";
//import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
//import { Collapse } from "react-collapse";
//import { NavLink } from 'react-router-dom'
import FormsOGLogin from '../../../components/Forms_Organizador/Login';
import SideNav from './../../../components/SideNav';


export default function Tela_Login_Organizador() {
    //let [search, setSearch] = useState(false);
    //let [login, setLogin] = useState(false);

    return (
        <>
            <SideNav />
            <div id="top-OG-Login"></div>

            <div id="main-OG-Login">
                <p id="OG-Login">Login</p>
                <hr id="divider-OG-Login" />
                <div id="down_login">
                    <FormsOGLogin/>
                </div>
            </div>
        </>
    );
}